import React from 'react';
import CSS from 'csstype';

const defaultActionButtons = (
    <button type="button" className="btn btn-secondary" data-dismiss="modal">
        Close
    </button>
);

interface IModalProps {
    children: JSX.Element[] | JSX.Element;
    title?: string | JSX.Element[] | JSX.Element;
    large?: boolean;
    id: string;
    style?: CSS.Properties;
    actionButtons: Array<JSX.Element | null>;
}

export default (props: IModalProps): JSX.Element => (
    <div
        className="modal fade"
        id={props.id}
        role="dialog"
        aria-labelledby={`${props.id}Label`}
        aria-hidden="true">
        <div className={`modal-dialog ${props.large && 'modal-lg'}`} role="document">
            <div className="modal-content">
                {props.title ? <div className="modal-header">
                    <h5 className="modal-title" id={`${props.id}Label`}>
                        {props.title}
                    </h5>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div> : <div className="d-flex flex-row-reverse pr-2"><button className="close" type="button" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button></div>}
                <div className="modal-body" style={props.style}>{props.children}</div>
                <div className="modal-footer">{props.actionButtons || defaultActionButtons}</div>
            </div>
        </div>
    </div>
);



// WEBPACK FOOTER //
// ./src/shared/Modal.tsx